<stb-accordion [rebrand]="true">
  @for (item of list; track item.trackId) {
    <stb-accordion-item [headerText]="item.title" [trackId]="item.trackId">
      <div [innerHTML]="item.content"></div>
    </stb-accordion-item>
  }
</stb-accordion>
